// @ts-check

import { liftSansNull } from './Util';

/**
 * @typedef {number} Size
 * @typedef {import('./coreTypes').ResultAtom} ResultAtom
 * @typedef {import('./coreTypes').JSResultAtom} JSResultAtom
 */


/**
 * @param {[ResultAtom, Size][]} resultAtomsAndSize 
 * @returns {JSResultAtom[]} 
 */
function parseDonors(resultAtomsAndSize) {
	return resultAtomsAndSize.flatMap(a => {
		if (a[0][0] === 'donor') return liftSansNull(parseNormalDonor(a));
		else if (a[0][0] === 'donor_legacy') return liftSansNull(parseLegacyDonor(a));
		else return [];
	});
}


/**
 * @param {[ResultAtom, Size]} d 
 * @returns {?JSResultAtom}
 */
function parseNormalDonor(d) {
	if (d[0][0] !== 'donor') return null;
	return [d[0][0], {
		id: d[0][1]['id'],
		firstName: d[0][1]['first_name'],
		lastName: d[0][1]['last_name'],
		donorSince: d[0][1]['donor_since'],
		alumYear: d[0][1]['alum_year'],
		campaigns: d[0][1]['campaigns'],
		campaignComments: d[0][1]['campaign_comments'],
		blockSize: d[1]
	}];
}

/**
 * @param {[ResultAtom, Size]} d 
 * @returns {?JSResultAtom}
 */
function parseLegacyDonor(d) {
	if (d[0][0] !== 'donor_legacy') return null;
	return [d[0][0], {
		firstName: d[0][1]['first_name'],
		lastName: d[0][1]['last_name'],
		campaigns: d[0][1]['campaigns'],
		campaignComments: d[0][1]['campaign_comments'],
		blockSize: d[1]
	}];
}


export default parseDonors;